// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

const proposalLineItemKeys = {
  all: ['proposalLineItem'] as const,
  proposalLineItem: (proposalLineItemId: string) =>
    [...proposalLineItemKeys.all, proposalLineItemId] as const,
};

export default proposalLineItemKeys;
